import { render, staticRenderFns } from "./BoutiqueInfos.vue?vue&type=template&id=326e9f16&"
import script from "./BoutiqueInfos.vue?vue&type=script&lang=js&"
export * from "./BoutiqueInfos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ILocalize: require('/opt/build/repo/components/svg/Localize.vue').default,IPhone: require('/opt/build/repo/components/svg/Phone.vue').default,IEmail: require('/opt/build/repo/components/svg/Email.vue').default,ISchedule: require('/opt/build/repo/components/svg/Schedule.vue').default})
